.banner {
  align-items: center;
  display: flex;
  align-items: center;
  background: var(--negative-10);
  width: 100%;
  gap: 10px;
  justify-content: center;
  padding: 8px 10px;
}

.message {
  display: flex;
  align-items: center;
  color: var(--red-70);
}

.container {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
